import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';
import { SERVER_URL } from './apiConstants';

const headers = {
  'Content-Type': 'application/json; charset=utf-8',
  'Access-Control-Allow-Origin': '*',
};
const resetpassword = 'reset-password';
export const resetPassword = createAsyncThunk('api/resetpassword', async (data) => {
  const body = {
    token: data.token,
    newPassword: data.Password,
  };

  return axios
    .post(`${SERVER_URL}/${resetpassword}`, body, { headers })
    .then((response) => {
      if (response.data && response.data.success) {
        return response.data;
      }
      return Promise.reject(new Error(response.data?.data?.message || 'Failed to reset password'));
    })
    .catch((error) => Promise.reject(error.response?.data || error));
});

const forgetPasswordSlice = createSlice({
  name: 'api',
  initialState: {
    loading: false,
    resetPasswordData: {},
    error: '',
  },
  extraReducers: {
    [resetPassword.pending]: (state) => {
      /* eslint-disable no-param-reassign */
      state.loading = true;
    },
    [resetPassword.fulfilled]: (state, action) => {
      state.loading = false;
      state.resetPasswordData = action.payload;
      if (action.payload && action.payload.success) {
        const message = action.payload.data?.message || 'Password reset successful';
        toast.success(message);
      }
    },
    [resetPassword.rejected]: (state, action) => {
      state.loading = false;
      state.error =
        action.error?.message || action.payload?.data?.message || 'Failed to reset password';
      const errorMessage =
        action.error?.message || action.payload?.data?.message || 'Error resetting password';
      toast.error(errorMessage);
    },
  },
});

export default forgetPasswordSlice.reducer;
